<template>
  <div>
    <b-form-group
      class="mb-3"
      id="telefone"
      label-for="input-telefone"
      :label="label"
      :invalid-feedback="inputInvalid"
      :class="col"
    >
      <b-form-input
        id="input-telefone"
        v-model="telefone"
        v-mask="mask"
        @blur="mascaraTelefone"
        :state="state"
        :disabled="disabled"
        :placeholder="inputText"
        autocomplete="off"
        trim
      >
      </b-form-input>
    </b-form-group>
  </div>
</template>

<script>
  export default {
    props: {
      label: String, // para dar nome ao campo
      inputText: String, // placeholder
      inputInvalid: String, // mensagem para campo invalido
      col: String, // definindo o tamanho do input na tela de acordo com cada caso
      disabled: Boolean, //para abilitar ou desabilitar o campo
      filtro: String, // envia dados do componente pai para o filho
      validado: Boolean // controla a cor dos campos
    },

  created() {
    if (this.filtro) {
      this.telefone = this.filtro;
    }
  },

    computed: {
      state(){
        if((this.validado || this.validado === false) && (this.estado === null || this.estado === false)){
          return this.validado
        }
        return this.estado
      },
      mask(){
        if(this.telefone){
          if(this.telefone.length <= 14){
            return '(##) ####-####'
          } else {
            return '(##) #####-####'
          }
        }else{
          return "";
        }
      }
    },


    data() {
      return {
        telefone: '',
        estado: null
      }
    },

    methods:{
      mascaraTelefone(){
        if(this.telefone.length === 0){
          this.estado = null
          return
        }
        if(this.telefone.length < 14){
          this.estado = false
          return
        }
        this.estado = true
        this.$emit("emitindoTelefone", this.telefone);
      },
      limpar(){
        this.telefone = "";
        this.estado = null;
        
      }
    }
  }
</script>

